import { bindScrollableRegionKeyboard } from '@theme/scrollable-region-a11y';

const SELECTOR = '.customer-reviews__list';

/** @param {HTMLElement} list */
function mountList(list) {
  bindScrollableRegionKeyboard(list, {
    axis: 'horizontal',
    getStep: () => {
      const card = list.querySelector('.customer-reviews__card');
      if (!(card instanceof HTMLElement)) return 320;

      const styles = getComputedStyle(list);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 40;
      return card.offsetWidth + gap;
    },
  });
}

/** @param {ParentNode} root */
function mountAll(root) {
  root.querySelectorAll(SELECTOR).forEach((el) => {
    if (el instanceof HTMLElement) {
      mountList(el);
    }
  });
}

function onReady() {
  mountAll(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady, { once: true });
} else {
  onReady();
}

document.addEventListener('shopify:section:load', (event) => {
  const target = /** @type {CustomEvent} */ (event).target;
  if (target instanceof HTMLElement) {
    mountAll(target);
  }
});
